import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { PricesFilter } from '@/scopes/prices/components/Filters/BaseFilter'
import { PricesUseCasesContext } from '@/scopes/prices/components/PricesUseCasesContext'
import {
  getFiltersSelector,
  getPricesSelector,
  mealplanFilterOptionsSelector,
} from '@/scopes/prices/components/selectors'
import { createPricesFilterClickEvent } from '@/scopes/prices/domain/analytics'
import { FiltersInPricesValues } from '@/scopes/prices/domain/filters/types'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { Dropdown, DropdownOption } from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { useIntl } from '../../../../intl'

export function MealPlanFilter() {
  const intl = useIntl()
  const { selectFilter } = React.useContext(PricesUseCasesContext)
  const { isEmpty: isEmptyResponse } = usePricesSelector(getFiltersSelector)
  const { options, selectedValue } = usePricesSelector(mealplanFilterOptionsSelector)
  const { sendEvent } = useAnalytics()
  const { loading: isFetching } = usePricesSelector(getPricesSelector)
  const { isTablet } = useBreakpoints()
  const doNotRender
    = (isEmpty(options) && !isEmptyResponse) || (!isTablet && !isEmptyResponse && options.length <= 1)
  if (doNotRender) {
    return null
  }
  const setSelection = (selection: FiltersInPricesValues) => selectFilter({ type: 'Mealplan', selection })

  const handleFilterChange = (value?: string) => {
    if (value) {
      setSelection(value)
      sendEvent(
        createPricesFilterClickEvent({
          element: 'dropdown',
          type: 'boardType',
          result: value,
        }),
      )
    }
    else {
      setSelection(undefined)
    }
  }

  return (
    <PricesFilter.Root>
      <PricesFilter.Label>{intl.formatMessage({ id: 'prices_filters_mealplan_label' })}</PricesFilter.Label>
      <PricesFilter.Control $isDisabled={isFetching || isEmpty(options)}>
        <Dropdown
          icon="IconCutlery"
          placeholder={intl.formatMessage({ id: 'prices_filters_mealplan_placeholder' })}
          value={selectedValue}
          onValueChange={handleFilterChange}
          disablePlaceholder
        >
          {options.map(({ name, value }) => (
            <DropdownOption key={value} value={value}>
              {name}
            </DropdownOption>
          ))}
        </Dropdown>
      </PricesFilter.Control>
    </PricesFilter.Root>
  )
}
